








import { Component, Prop, Vue } from 'vue-property-decorator'

import { IMAGE_LAZYLOAD_CLASS } from '~/configs/images'
import { placeholderSrc } from '~/utils/images'

@Component
export default class BBLazy extends Vue {
  @Prop({
    type: String
  })
  src: string

  @Prop({
    type: [String, Number],
    required: false,
    default: ''
  })
  width: string | number

  @Prop({
    type: [String, Number],
    required: false,
    default: ''
  })
  height: string | number

  @Prop({
    type: Boolean,
    required: false,
    default: false
  })
  noStyles: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  noLazy: boolean

  get secureSrc () {
    return this.src || '/img/lazy-error.jpg'
  }

  get placeholder () {
    if (this.noLazy) {
      return this.secureSrc
    }

    return placeholderSrc({
      width: this.width,
      height: this.height
    })
  }

  get attributes () {
    const lazyAttrs = !this.noLazy
      ? {
        class: [
          IMAGE_LAZYLOAD_CLASS
        ]
      }
      : {}

    if (this.secureSrc.includes(',')) {
      lazyAttrs['data-srcset'] = this.secureSrc
    } else {
      lazyAttrs['data-src'] = this.secureSrc
    }

    const styles = this.noStyles ? null : {
      style: {
        ...this.width ? { 'max-width': this.width + 'px' } : null,
        ...this.height ? { 'max-height': this.height + 'px' } : null
      }
    }

    // HTML-атрибуты для резервирования места (CLS fix)
    const dimensionAttrs = {
      ...(this.width ? { width: this.width } : {}),
      ...(this.height ? { height: this.height } : {})
    }

    return {
      ...this.$attrs,
      ...lazyAttrs,
      ...styles,
      ...dimensionAttrs
    }
  }
}
